import { render, staticRenderFns } from "./instProductSelector.vue?vue&type=template&id=3880b1f2&scoped=true"
import script from "./instProductSelector.vue?vue&type=script&lang=js"
export * from "./instProductSelector.vue?vue&type=script&lang=js"
import style0 from "./instProductSelector.vue?vue&type=style&index=0&id=3880b1f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3880b1f2",
  null
  
)

export default component.exports